import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

// Services
import { CommonService } from '../../services/common/common.service';
import { LoggerService } from '../../services/logger/logger.service';
import { NetworkService } from '../../services/network/network.service';

export const ConfigFileGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const logger = inject(LoggerService);
  const common = inject(CommonService);
  const network = inject(NetworkService);

  return new Observable((observer) => {
    common.getConfigFile().subscribe({
      error: () => {
        logger.consoleLog('ConfigFileGuard', 'canActivate', 'getConfigFile => blockedApp');
        network.blockedApp = true;
      },
    });

    observer.next(true);
  });
};
